import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

interface PollVotersDialogSkeletonProps {
  /** Number of option groups to mirror while voters load. */
  optionCount: number;
}

/**
 * Loading placeholder for the poll voters dialog: one block per option with a
 * label line and a couple of voter rows (avatar + name).
 */
export const PollVotersDialogSkeleton: FC<PollVotersDialogSkeletonProps> = ({ optionCount }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {Array.from({ length: optionCount }).map((_, groupIndex) => (
        // oxlint-disable-next-line react/no-array-index-key
        <Box key={groupIndex} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="text" width="45%" height={20} />
          {Array.from({ length: 2 }).map((__, rowIndex) => (
            // oxlint-disable-next-line react/no-array-index-key
            <Box key={rowIndex} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="circular" width={28} height={28} />
              <Skeleton variant="text" width="35%" height={18} />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
